import { SearchOutlined } from '@ant-design/icons';
import { Input, Modal } from 'antd';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ModifierOptionType, ModifierType } from '../../redux/data/dataTypes';
import ModifierList from './ModifierList';

interface ModifierListWithWrapperProps {
  onOptionsSelect?: (options: ModifierOptionType[]) => void;
}

const ModifierListWithWrapper: FC<ModifierListWithWrapperProps> = ({ onOptionsSelect }) => {
  const { t } = useTranslation();
  const [searchTxt, setSearchTxt] = useState('');
  const [selectedModifier, setSelectedModifier] = useState<ModifierType | null>(null);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleShowOptions = (modifier: ModifierType) => {
    setSelectedModifier(modifier);
    setIsModalVisible(true);
  };

  const handleSelectOptions = (options: ModifierOptionType[]) => {
    setIsModalVisible(false);
    onOptionsSelect?.(options);
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
    setSelectedModifier(null);
  };

  return (
    <div className="flex flex-col h-full">
      <div className="flex items-center gap-3 mb-5 p-3 bg-[#f6f8fc] dark:bg-gray-700 rounded-xl shadow-sm">
        <div className="flex-1 relative">
          <SearchOutlined className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 dark:text-gray-300" />
          <Input
            placeholder={t('common:type_something')}
            onChange={(e) => setSearchTxt(e.target.value)}
            className="flex-1 bg-white dark:bg-gray-600 border border-gray-200 dark:border-gray-500 min-h-[42px] pl-10 rounded-lg text-gray-800 dark:text-white shadow-sm focus:shadow-md transition-shadow duration-200"
            value={searchTxt}
          />
        </div>
      </div>
      <div className="flex-1">
        <ModifierList searchTxt={searchTxt} onItemPress={handleShowOptions} className="p-2" />
      </div>
      <Modal
        title={
          <div className="text-lg font-semibold text-gray-800 dark:text-white">
            {selectedModifier?.name}
          </div>
        }
        open={isModalVisible}
        onCancel={handleModalClose}
        footer={null}
        width={400}
        className="modifier-options-modal"
      >
        {selectedModifier && (
          <div className="space-y-2">
            {selectedModifier.options?.map((option) => (
              <div
                key={option.ID}
                className="flex items-center justify-between p-3 bg-white dark:bg-gray-600 hover:bg-gray-50 dark:hover:bg-gray-500 rounded-lg cursor-pointer transition-all duration-200 shadow-sm hover:shadow-md"
                onClick={() => handleSelectOptions([option])}
              >
                <span className="font-medium text-gray-800 dark:text-white">{option.name}</span>
                <span className="bg-gray-100 dark:bg-gray-500 text-frenchBlue dark:text-white font-bold px-3 py-1 rounded-lg text-sm">
                  {option.price} SAR
                </span>
              </div>
            ))}
          </div>
        )}
      </Modal>
    </div>
  );
};

export default ModifierListWithWrapper;
